import React, {Component} from 'react'
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

const styles = theme => ({
  root: {
    width: '50%',
    paddingRight: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  lgContainer: {
    width: '100%',
  },
  smContainer: {
    width: '100%',
    paddingRight: 0,
    marginBottom: 0,
  },
  selectField: {
    width: '100%',
  },
  lgSize: {
    fontSize: '2rem',
  },
  smSize: {
    marginTop: '6px!important',
  },
  valueChanged: {
    color: theme.palette.primary[500],
  },
});

class ProjectSelectField extends Component {
  state = {
    value: '',
    orginalValue: '',
    valueChanged: false,
    toggleable: false,
    toggled: false,
  };

  componentDidMount() {
    this.updateState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.updateState(nextProps)
    }
  }

  updateState(props) {
    this.setState({value: props.value, orginalValue: props.value, toggleable: props.toggleable, valueChanged: false});
  }

  handleChange = alias => event => {
    const value = event.target.value

    if (value !== this.state.value) {
      let newState = {[alias]: event.target.value, valueChanged: false}

      if (value !== this.state.orginalValue) {
        newState.valueChanged = true
      }
      this.setState(newState);
    }
  };

  handleSelectToggle = () => {
    this.setState({toggled: true});
  }

  handleClickSave = () => {

    this.props.save(this.props.id, this.props.alias, this.state.value)
    this.setState({valueChanged: false, orginalValue: this.state.value, toggled: false});
  };

  render() {
    const {classes, alias, size, label, options, toggleable, id} = this.props;
    const {value, valueChanged, toggled} = this.state;

    return (<>
          {(!toggleable || toggled) && <FormControl className={classes.root + ' ' +
          (size ? classes[size + 'Container'] : null)}>
            <InputLabel htmlFor={'project-select-field-' + alias}>{label}</InputLabel>
            <Select
                value={value}
                className={classes.selectField + ' ' +
                (size ? classes[size + 'Size'] : null) + ' ' +
                (valueChanged ? classes.valueChanged : null)
                }
                onChange={this.handleChange('value')}
                inputProps={{
                  alias: 'project-select-field-' + alias,
                  id: 'project-select-field-' + alias,
                }}
                endAdornment={
                  valueChanged && <InputAdornment position="end">
                    <IconButton
                        color="primary"
                        aria-label="Save"
                        onClick={this.handleClickSave}
                    >
                      <FontAwesomeIcon size="xs" icon={['fal', 'save']}/>
                    </IconButton>
                  </InputAdornment>
                }
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {options && options.map((option, key) =>
                  <MenuItem value={option.value} key={key}>{option.label}</MenuItem>
              )}
            </Select>
          </FormControl>}
          {(toggleable && !toggled && options && options.length > 0) && <IconButton
              color="primary"
              aria-label="Add"
              onClick={this.handleSelectToggle}
          >
            <FontAwesomeIcon size="xs" icon={['fal', 'plus']}/>
          </IconButton>}
        </>
    )
  }
}

ProjectSelectField.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProjectSelectField);
